module.exports = __webpack_public_path__ + "static/media/Javier Rodriguez Soler.78441910.jpg";